import { FormField, Text, Input, Button } from '@wix/design-system';
import React, { useContext, useState, useRef } from 'react';
import { containsUrl, VIDEO_TYPE, generateId } from 'ricos-content';
import { RicosContext, EditorContext } from 'ricos-context';
import { ReactPlayer } from 'wix-react-player';
import { MEDIA_POPOVERS_BUTTONS_NAMES_BI } from 'wix-rich-content-common';
import { s as styleInject } from './style-inject.es-e7b07dd7.js';
import { EMBED_TAB_URL_INPUT, EMBED_TAB_SUBMIT_BUTTON } from './dataHooks.js';
import { isVideoMetadata } from './toolbar/is-video-metadata.js';

var css_248z = ".t1rSL{--wsr-color-B10:var(--rcp-color-primary)}.t1rSL button:hover{--wsr-color-B10:var(--rcp-color-hover)}.ADRGM{--wds-input-value-font-size-medium:14px}";
var classes = {"tabs":"t1rSL","input":"ADRGM"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const EmbedVideo = (_a) => {
  var _b = _a, {
    componentData,
    helpers,
    closeModal
  } = _b, props = __objRest(_b, [
    "componentData",
    "helpers",
    "closeModal"
  ]);
  var _a2, _b2, _c, _d;
  const { t } = useContext(RicosContext);
  const { getEditorCommands } = useContext(EditorContext);
  const [url, setUrl] = useState(
    ((_b2 = (_a2 = componentData == null ? void 0 : componentData.video) == null ? void 0 : _a2.src) == null ? void 0 : _b2.id) ? "" : ((_d = (_c = componentData == null ? void 0 : componentData.video) == null ? void 0 : _c.src) == null ? void 0 : _d.url) || ""
  );
  const [submittedInvalidUrl, setSubmittedInvalidUrl] = useState(false);
  const inputRef = useRef(null);
  const updateVideoMetadata = (videoNodeId, metadata) => {
    var _a3, _b3;
    (_b3 = (_a3 = getEditorCommands()).updateBlock) == null ? void 0 : _b3.call(
      _a3,
      videoNodeId,
      VIDEO_TYPE,
      {
        thumbnail: {
          src: { url: metadata.thumbnail_url },
          width: metadata.thumbnail_width,
          height: metadata.thumbnail_height
        },
        title: metadata.title
      }
    );
  };
  const onUrlUploadClick = () => {
    var _a3, _b3;
    (_a3 = helpers.onPluginsPopOverClick) == null ? void 0 : _a3.call(helpers, {
      pluginId: VIDEO_TYPE,
      buttonName: MEDIA_POPOVERS_BUTTONS_NAMES_BI.embed
    });
    if (!url || !ReactPlayer.canPlay(url)) {
      setSubmittedInvalidUrl(true);
      (_b3 = inputRef.current) == null ? void 0 : _b3.focus();
      return;
    }
    const videoData = (() => {
      const updatedVideo = __spreadProps(__spreadValues({}, componentData.video), { src: { url } });
      return props.nodeId ? { containerData: componentData.containerData, video: updatedVideo } : __spreadProps(__spreadValues({}, componentData), { video: updatedVideo });
    })();
    const nodeId = props.nodeId || generateId();
    setTimeout(() => {
      props.nodeId === void 0 ? getEditorCommands().insertBlockWithBlankLines(VIDEO_TYPE, __spreadProps(__spreadValues({}, videoData), { id: nodeId })) : getEditorCommands().setBlock(props.nodeId, VIDEO_TYPE, videoData);
    });
    if (helpers == null ? void 0 : helpers.onVideoSelected) {
      helpers.onVideoSelected(url, (data) => {
        const { oembed } = data;
        if (typeof oembed !== "object" || oembed === null || !isVideoMetadata(oembed)) {
          return;
        }
        return updateVideoMetadata(nodeId, oembed);
      });
    }
    closeModal();
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    FormField,
    {
      label: /* @__PURE__ */ React.createElement(Text, { size: "tiny", weight: "thin" }, t("VideoModal_Embed_Title")),
      status: submittedInvalidUrl ? "error" : void 0,
      statusMessage: submittedInvalidUrl ? t("SoundCloudUploadModal_Input_InvalidUrl") : void 0
    },
    /* @__PURE__ */ React.createElement(
      Input,
      {
        inputRef: (ref) => {
          inputRef.current = ref;
        },
        className: classes.input,
        type: "url",
        id: "dropdown-text-input",
        autocomplete: "off",
        dataHook: EMBED_TAB_URL_INPUT,
        value: url,
        onChange: (e) => {
          setSubmittedInvalidUrl(false);
          setUrl(e.target.value);
        },
        placeholder: t("EmbedURL_Placeholder"),
        onBlur: () => {
          if (url && !containsUrl(url)) {
            setSubmittedInvalidUrl(true);
          }
        }
      }
    )
  ), /* @__PURE__ */ React.createElement(Button, { dataHook: EMBED_TAB_SUBMIT_BUTTON, onClick: onUrlUploadClick }, t("VideoModal_Embed_ButtonText")));
};

export { EmbedVideo as E, classes as c };
//# sourceMappingURL=embed-video-91705df7.js.map
